module.exports = __webpack_public_path__ + "img/bg_quantum_room.e45db847.jpg";